// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DPU-time-slider-container {
  width: 100%;
  padding: 5px 10px;
  margin-top: 3px;
  border-top: 1px solid var(--border-color-1);
  /* border-bottom: 1px solid gray; */
}

.DPU-time-slider-container .time-slider {
  width: 100%;
  margin: 0;
}

.DPU-time-slider-container .time-slider-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 5px;
}
.DPU-time-slider-container .checkbox-container {
  display: flex;
  align-items: center;
}

/* .DPU-time-slider-container .checkbox-container input {
  margin-right: 5px;
} */

.DPU-time-slider-container .ruler-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.DPU-time-slider-container .ruler {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;
}

.DPU-time-slider-container .ruler div {
  width: 2px;
  height: 6px;
  background: #888;
}

.DPU-time-slider-container .ruler div.big {
  height: 10px;
  background: var(--color-text-1);
}

.DPU-time-slider-container .ticks {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 10px;
  /* margin-top: 5px; */
}

.DPU-time-slider-container .ticks span {
  text-align: center;
}
.DPU-time-slider-container .ticks span:nth-child(1) {
  margin-left:5px;
}
.DPU-time-slider-container .ticks span:nth-child(2) {
  margin-left:10px;
}
.DPU-time-slider-container .ticks span:nth-child(3) {
  margin-left:7px;
}


.DPU-time-slider-container .container-range-time {
  width: 100%;
  padding: 0 10px;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/mapWeather/daylight.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX","sourcesContent":[".DPU-time-slider-container {\r\n  width: 100%;\r\n  padding: 5px 10px;\r\n  margin-top: 3px;\r\n  border-top: 1px solid var(--border-color-1);\r\n  /* border-bottom: 1px solid gray; */\r\n}\r\n\r\n.DPU-time-slider-container .time-slider {\r\n  width: 100%;\r\n  margin: 0;\r\n}\r\n\r\n.DPU-time-slider-container .time-slider-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  width: 100%;\r\n  margin-bottom: 5px;\r\n}\r\n.DPU-time-slider-container .checkbox-container {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n/* .DPU-time-slider-container .checkbox-container input {\r\n  margin-right: 5px;\r\n} */\r\n\r\n.DPU-time-slider-container .ruler-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n\r\n.DPU-time-slider-container .ruler {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  padding: 0 10px;\r\n}\r\n\r\n.DPU-time-slider-container .ruler div {\r\n  width: 2px;\r\n  height: 6px;\r\n  background: #888;\r\n}\r\n\r\n.DPU-time-slider-container .ruler div.big {\r\n  height: 10px;\r\n  background: var(--color-text-1);\r\n}\r\n\r\n.DPU-time-slider-container .ticks {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  font-size: 10px;\r\n  /* margin-top: 5px; */\r\n}\r\n\r\n.DPU-time-slider-container .ticks span {\r\n  text-align: center;\r\n}\r\n.DPU-time-slider-container .ticks span:nth-child(1) {\r\n  margin-left:5px;\r\n}\r\n.DPU-time-slider-container .ticks span:nth-child(2) {\r\n  margin-left:10px;\r\n}\r\n.DPU-time-slider-container .ticks span:nth-child(3) {\r\n  margin-left:7px;\r\n}\r\n\r\n\r\n.DPU-time-slider-container .container-range-time {\r\n  width: 100%;\r\n  padding: 0 10px;\r\n  margin: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
